export * from './cache';
export * from './types';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/apollo-cache/lib/index.js
// module id = 295
// module chunks = 0